<template>
  <main-layout class="operate-completed" page-title="操作完成">
    <div slot="main-content" class="main-content">
      <div class="completed-box">
        <i class="iconfont icon-completed"></i>
      </div>
      <div class="title">操作成功</div>
      <div class="desc"></div>
      <div class="tip" v-if="$route.query.form === 'remote'">
        已发起远程打印，请自行前往所选站点领取合格证
      </div>
      <div class="tip" v-else>你可以进行以下操作</div>
      <div class="btns">
        <el-button
          type="primary"
          @click="goClientPage('/Certificate/batchPrint')"
          >返回合格证批量打印列表</el-button
        >
        <el-button
          type="primary"
          @click="goClientPage('/Certificate/printRecord')"
          >返回合格证打印记录列表</el-button
        >
        <el-button type="primary" plain @click="goPage('/home/home')">
          返回首页
        </el-button>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layout/MainLayout";
import { getStorage } from "@/utils/storage";

export default {
  name: "operateCompleted",
  // mixins: [sameIn],
  components: {
    MainLayout,
  },
  data() {
    return {
      companyId: "",
      farmId: "",
    };
  },
  mounted() {
    // 获取企业，农场id
    const farminfo = getStorage("FARMINFO");
    if (farminfo) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
  },
  methods: {
    goPage(page) {
      window.open(
        window.location.origin +
          `/index.html#${page}/company=${this.companyId}&farm=${this.farmId}`,
        "_self"
      );
    },
    goClientPage(page) {
      this.$router.push({
        path: page,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.main-content {
  width: 1200px;
  height: 100%;
  background: #fff;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 120px;
  box-sizing: border-box;
  .completed-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    height: 70px;
    border: 2px solid #64c3a4;
    border-radius: 40px;
    i {
      margin: 0;
      font-size: 35px;
      color: #64c3a4;
    }
  }
  .title {
    margin-top: 15px;
    font-weight: bold;
    font-size: 24px;
    color: #64c3a4;
  }
  .desc {
    margin-top: 30px;
  }
  .tip {
    margin-top: 5px;
    color: #888888;
    font-size: 16px;
    padding-bottom: 8px;
  }
  .btns {
    display: flex;
    flex-direction: column;
    ::v-deep .el-button {
      padding: 12px 0;
      margin-left: 0;
      margin-top: 12px;
      width: 200px;
      font-size: 16px;
    }
  }
}
</style>
